module.exports = __webpack_public_path__ + "static/media/asset-creation.b0c526ef.svg";